import { useEffect, useMemo, useState } from "react";
import { usePageNameContext } from "../../contexts/PageTitleContext";

import LoadingWheel from "../../components/shared/LoadingWheel";
import { PlusSmallIcon } from "@heroicons/react/24/outline";
import { IPartBin } from "../../models/PartBin";
import usePartBins from "../../data/usePartBins";
import PartBinsTable from "../../components/partBins/PartBinsTable";
import PartBinsModal from "../../components/partBins/PartBinsModal";
import { ButtonInput } from "../../components/shared/Inputs/ButtonInput";

export default function PartBins() {
  const { setInfo } = usePageNameContext();
  const { partBins: allPartBins } = usePartBins();
  const [partBin, setPartBin] = useState<IPartBin | undefined>(undefined);
  const [searchTerm, setSearchTerm] = useState("");
  const [createOpen, setCreateOpen] = useState(false);

  useEffect(() => {
    setInfo({
      name: "Part Bins",
      desc: "View and manage the bins parts get picked into",
    });
  }, []);

  const filteredPartBins = useMemo(() => {
    const normalizedSearchTerm = searchTerm?.trim()?.toLowerCase();

    return allPartBins.data?.data?.filter((bin) =>
      bin.name?.toLowerCase()?.includes(normalizedSearchTerm)
    ) ?? [];
  }, [allPartBins.data, searchTerm]);

  const handleSetPartBin = (bin: IPartBin) => {
    setPartBin(bin);
    setCreateOpen(true);
  };

  const handleAddPartBin = () => {
    setPartBin(undefined);
    setCreateOpen(true);
  };

  return allPartBins.isLoading ? (
    <div className="mt-8 min-h-[50vh] my-4 p-4 bg-white rounded-lg shadow">
      <LoadingWheel />
    </div>
  ) : (
    <>
      <PartBinsModal open={createOpen} setOpen={setCreateOpen} partBin={partBin} />
      <div className="mt-4 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
        <div className="w-full sm:max-w-sm">
          <label htmlFor="part-bin-search" className="block text-sm font-medium text-gray-700">
            Search bins
          </label>
          <input
            id="part-bin-search"
            type="text"
            value={searchTerm}
            onChange={(event) => setSearchTerm(event.target.value)}
            placeholder="Search by bin name"
            className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500"
          />
        </div>

        {/* Button for adding a new bin */}
        <ButtonInput isSubmit={false} onClick={() => handleAddPartBin()} classes={undefined} >
          <div className="flex items-center">
            <PlusSmallIcon className="h-5 w-5 mr-2" />
            Add New Bin
          </div>
        </ButtonInput>

      </div>

      {/* Table of part bins */}
      <PartBinsTable partBins={filteredPartBins} setPartBin={handleSetPartBin} />
    </>
  );
}
